
export default function Features() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Military-Grade Encryption',
      description: 'Your data is protected with AES-256 encryption, the same standard used by governments and security experts worldwide to ensure maximum privacy and security.',
    },
    {
      icon: 'ri-speed-line',
      title: 'Lightning Fast Speeds',
      description: 'Enjoy seamless browsing, streaming, and downloading with our optimized servers. Experience minimal speed loss while maintaining complete security and privacy.',
    },
    {
      icon: 'ri-global-line',
      title: 'Global Server Network',
      description: 'Connect to servers in multiple countries around the world. Access geo-restricted content and enjoy a truly borderless internet experience wherever you are.',
    },
    {
      icon: 'ri-eye-off-line',
      title: 'No-Logs Policy',
      description: 'We never track, collect, or share your private data. Your online activities remain completely private and anonymous with our strict no-logs policy.',
    },
    {
      icon: 'ri-device-line',
      title: 'Multi-Device Support',
      description: 'Protect all your devices with a single account. Our VPN works seamlessly across Windows, Mac, iOS, Android, and more platforms simultaneously.',
    },
    {
      icon: 'ri-customer-service-line',
      title: '24/7 Customer Support',
      description: 'Our dedicated support team is always ready to help you. Get assistance anytime you need it through email, chat, or phone support channels.',
    },
  ];

  return (
    <section id="features" className="py-20 bg-gradient-to-b from-white to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Why Choose Our VPN?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Discover the powerful features that make our VPN the perfect choice for protecting your online privacy and security in today's digital world.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-3xl text-blue-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
